import {request, serviceUrl} from "@/utils/request";

//告警收敛策略列表
export function getList(spaceId = null, categoryId = null, deviceId = null, pointId = null) {
  return request({
    url: serviceUrl.deviceService + '/alarm/convergence/list',
    params: {
      spaceId, categoryId, deviceId, pointId
    }
  })
}
//新增告警收敛策略\编辑告警等级策略
export function saveOrUpdate(params) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/alarm/convergence/saveOrUpdate',
    data: params
  })
}

//删除告警收敛策略
export function deleteUpgrade(id) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/alarm/convergence/delete',
    params: {id}
  })
}